import { defineRecipe } from "@chakra-ui/react";

const linkRecipe = defineRecipe({
    base: {
        color: "ebonyClay.500",
        fontSize: "16px",
        focusRing: "none",
        textDecoration: "underline",
        _hover: {
            textDecoration: "underline"
        },
        _disabled: {
            color: "gray.400",
            _hover: {
                cursor: "not-allowed",
                textDecoration: "underline"
            }
        },
        _focus: {
            outline: "none",
            boxShadow: "none"
        },
        _focusVisible: {
            outline: "none",
            boxShadow: "none"
        }
    },
    variants: {
        variant: {
            link: {
                color: "royalBlue.500",
                _active: {
                    color: "royalBlue.500"
                }
            },
            focusRing: {
                none: {
                    focusRing: "none"
                }
            }
        }
    }
});

export default linkRecipe;
